<template>
  <section class="max-w-screen-xl mx-auto p-5">
            <form>
                <div
                    class="max-w-7xl mx-auto rounded-lg py-10 px-4 md:px-20 mt-5 md:mt-20" style="background:linear-gradient(to right, #5D2BFF, #2C86DE)">
                    <p class="text-white text-center md:px-32 tracking-wide text-lg hidden md:block">Booking Confirmed - you're all set!
                    </p>
                    <p class="text-white text-center md:px-32 tracking-wide text-lg md:hidden block">The trial meeting booking has been submitted successfully.</p>
                    <div class="mt-20 w-11/12 mx-auto bg-white rounded-lg py-5 px-5 md:px-20 relative">
                        <div class="absolute inset-x-0 flex justify-center" style="top:-2rem">
                            <div
                                class="w-16 h-16 rounded-full bg-white flex justify-center items-center border-2" style="border-color:#4852F1">
                                <svg class="w-8" viewBox="0 -3 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">

                                    <title>checkmark</title>
                                    <desc>Created with Sketch Beta.</desc>
                                    <defs>

                                    </defs>
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                        sketch:type="MSPage">
                                        <g id="Icon-Set-Filled" sketch:type="MSLayerGroup"
                                            transform="translate(-518.000000, -1039.000000)" fill="#4852F1">
                                            <path
                                                d="M548.783,1040.2 C547.188,1038.57 544.603,1038.57 543.008,1040.2 L528.569,1054.92 L524.96,1051.24 C523.365,1049.62 520.779,1049.62 519.185,1051.24 C517.59,1052.87 517.59,1055.51 519.185,1057.13 L525.682,1063.76 C527.277,1065.39 529.862,1065.39 531.457,1063.76 L548.783,1046.09 C550.378,1044.46 550.378,1041.82 548.783,1040.2"
                                                id="checkmark" sketch:type="MSShapeGroup">

                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="flex flex-col md:flex-row space-y-6 md:space-y-0 md:justify-between justify-center items-center pt-10">
                            <div>
                                <p class="text-center md:text-left">You are booked to meet <strong>{{ bookingData.attenderName }}</strong> on</p>
                                <p class="font-bold text-center text-2xl md:text-4xl mt-3">{{ bookingData.date }}</p>
                            </div>
                            <div>
                                <a :href="bookingData.calendarLink"
                                    class="px-5 md:px-10 py-2 text-lg flex justify-center items-center space-x-6 rounded-full" style="background:#83EDA3; border:none">
                                    <svg class="w-5 md:w-10" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M18 15.75C16.7574 15.75 15.75 16.7574 15.75 18C15.75 19.2426 16.7574 20.25 18 20.25C19.2426 20.25 20.25 19.2426 20.25 18C20.25 16.7574 19.2426 15.75 18 15.75ZM14.25 18C14.25 15.9289 15.9289 14.25 18 14.25C20.0711 14.25 21.75 15.9289 21.75 18C21.75 18.7643 21.5213 19.4752 21.1287 20.068L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L20.068 21.1287C19.4752 21.5213 18.7643 21.75 18 21.75C15.9289 21.75 14.25 20.0711 14.25 18Z"
                                            fill="#1C274C" />
                                        <path
                                            d="M7.75 2.5C7.75 2.08579 7.41421 1.75 7 1.75C6.58579 1.75 6.25 2.08579 6.25 2.5V4.07926C4.81067 4.19451 3.86577 4.47737 3.17157 5.17157C2.47737 5.86577 2.19451 6.81067 2.07926 8.25H21.9207C21.8055 6.81067 21.5226 5.86577 20.8284 5.17157C20.1342 4.47737 19.1893 4.19451 17.75 4.07926V2.5C17.75 2.08579 17.4142 1.75 17 1.75C16.5858 1.75 16.25 2.08579 16.25 2.5V4.0129C15.5847 4 14.839 4 14 4H10C9.16097 4 8.41527 4 7.75 4.0129V2.5Z"
                                            fill="#1C274C" />
                                        <path
                                            d="M22 12V14C22 14.2053 22 14.405 21.9998 14.5992C21.0368 13.4677 19.6022 12.75 18 12.75C15.1005 12.75 12.75 15.1005 12.75 18C12.75 19.6022 13.4677 21.0368 14.5992 21.9998C14.405 22 14.2053 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12C2 11.161 2 10.4153 2.0129 9.75H21.9871C22 10.4153 22 11.161 22 12Z"
                                            fill="#1C274C" />
                                    </svg>
                                    <p class="">Add to calender</p>
                                </a>
                            </div>
                        </div>
                        <p class="mt-5 text-center text-sm">A confirmation email has been sent to you with instructions
                            of how to join the meeting on the day.</p>
                    </div>
                    <div class="mt-5">
                        <div class="text-center text-white">Any questions? <a :href="`mailto:${initData.infoEmail}`" class="underline">Email us</a> and we'd be happy to help.</div>
                        <div class="text-center text-white">Need to Reschedule? If you need to make changes to your meeting, please <a :href="`mailto:${initData.infoEmail}`" class="underline">click here</a></div>
                    </div>
                </div>
            </form>
        </section>
    <!-- <div class="py-8 lg:py-8 w-full min-h-screen flex flex-col lg:flex-row items-center lg:px-10 xl:px-40">
        <div class="lg:w-7/12 px-8 lg:px-4">
            <div class="-mb-4">
                <img src="https://cdn.satscompanion.com/images/meeting-booking/icon-tick.png"
                     alt="tick"
                     class="w-8 mx-auto">
            </div>
            <div class="border-2 border-secondary p-10 rounded-lg">
                <h2 class="text-2xl font-extrabold text-purple-600">
                    <span>{{ initData.productName }} Trial Request - You're all set!</span>
                </h2>
                <div v-if="initData.webinar" class="mt-4">
                    Thank you for your interest in a free 1-week trial of {{ initData.productName }} and for booking your training webinar.
                </div>
                <div v-if="initData.webinar" class="mt-4">
                    A confirmation email will be sent to you with instructions on how to
                    join the meeting on the day.
                </div>
                <div v-if="initData.webinar" class="mt-4">
                    Your trial will be set up once the training session has been attended.
                </div>
                <div class="mt-8">You are <span v-if="isReschedule">rescheduled</span><span v-else>booked</span> to meet <span class="font-extrabold">{{ bookingData.attenderName
                }}</span> on</div>
                <div class="flex items-center mt-8">
                    <div>
                        <img src="https://cdn.satscompanion.com/images/meeting-booking/icon-calendar.png"
                             alt=""
                             class="w-12">
                    </div>
                    <div class="text-2xl ml-4 font-extrabold text-purple-600">
                        {{ bookingData.date }}
                    </div>
                </div>
                <a :href="bookingData.calendarLink"
                   target="_blank"
                   class="text-purple-600 ml-16 flex items-center cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="h-5 w-5"
                         viewBox="0 0 20 20"
                         fill="currentColor">
                        <path fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                              clip-rule="evenodd" />
                    </svg>
                    <span class="ml-1">Add to calendar</span>
                </a>
                <div v-if="!initData.webinar" class="mt-8">
                    A confirmation email will be sent to you with instructions on how to
                    join the meeting on the day.
                </div>
                <div class="mt-8">
                    Any questions? <a href="mailto:school@satscompanion.com" class="text-purple-600">Email us</a> and we'd be happy help.
                </div>
            </div>

            <div v-if="!initData.webinar" class="mt-8">
                <span class="font-extrabold">Need to Reschedule?... </span>
                <span>If you need to make changes to your meeting, please click </span>
                <a :href="`mailto:${initData.infoEmail}`"
                   class="text-purple-600">here</a>
            </div>
        </div>

        <div class="mt-16 lg:mt-0 px-8 lg:px-4 flex flex-col items-center justify-center lg:w-5/12">
            <div>
                <img :src="initData.logoUrl"
                     alt="logo"
                     class="w-32">
            </div>

            <div class="mt-6 text-center">
                <div class="flex items-center justify-center space-x-4">
                    <a v-for="(imageUrl, url) in initData.socialMedia"
                       :key="url"
                       :href="url"
                       target="_blank">
                        <img :src="imageUrl"
                             class="h-8 w-auto">
                    </a>
                </div>
                <div class="mt-2">
                    In the meantime, follow us on social media for free resources, tips and special offers.
                </div>
            </div>
        </div>
    </div> -->
</template>
  
<script>
export default {
    name: "ThankYou",

    props: ["bookingData", "initData"],

    computed: {
        isReschedule() {
            const urlParams = new URLSearchParams(location.search);

            return urlParams.get("res") == 1;
        },
    },
};
</script>
  
<style>
.add:hover {
    text-decoration: underline;
    color: rgb(0, 184, 234);
}
</style>
